import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PatchPickUpLocationBoDto, PickUpLocationDto } from "../types/api/api-types";
import { PickUpLocationFormData } from "../types/forms/auth/registerFormData.form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { axiosApi } from "./axios";

const patchPickUpLocation = async ({ data, id }: { data: PickUpLocationFormData; id: string }) => {
  return axiosApi.patch<PickUpLocationDto>(`/pickup-location/${id}`, data);
};

export const usePatchPickUpLocation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("boClients");
  return useMutation({
    mutationFn: patchPickUpLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company"] });
      toast.success(t("pickUpLocationApi.updateSuccess"));
    },
    onError: () => {
      toast.error(t("pickUpLocationApi.updateError"));
    },
  });
};

const patchPickUpLocationBo = async ({
  data,
  id,
}: {
  data: PatchPickUpLocationBoDto;
  id: string;
}) => {
  return axiosApi.patch(`/pickup-location/bo/${id}`, data);
};

export const usePatchPickUpLocationBo = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("boClients");
  return useMutation({
    mutationFn: patchPickUpLocationBo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getFullCompanyBO"] });
      queryClient.invalidateQueries({ queryKey: ["getCompanyBOV1"] });
      toast.success(t("pickUpLocationApi.updateSuccess"));
    },
    onError: () => {
      toast.error(t("pickUpLocationApi.updateError"));
    },
  });
};

const deletePickUpLocation = async (id: string) => {
  return axiosApi.delete(`/pickup-location/${id}`);
};

export const useDeletePickUpLocation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("boClients");
  return useMutation({
    mutationFn: deletePickUpLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company"] });
      toast.success(t("pickUpLocationApi.deleteSuccess"));
    },
    onError: () => {
      toast.error(t("pickUpLocationApi.deleteError"));
    },
  });
};

const createPickUpLocation = async (data: PickUpLocationFormData) => {
  return axiosApi.post(`/pickup-location`, data);
};

export const useCreatePickUpLocation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("boClients");
  return useMutation({
    mutationFn: createPickUpLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company"] });
      toast.success(t("pickUpLocationApi.createSuccess"));
    },
    onError: () => {
      toast.error(t("pickUpLocationApi.createError"));
    },
  });
};
